import { useTranslation } from 'react-i18next';

import {
    Body1,
    Button,
    Modal,
    Stack,
} from '@myphx-engineering/phx-design-system';

export const PharmacyDoesNotCarryConfirmationModal = ({
    isOpen,
    close,
    onChooseDifferentPharmacy,
    onSendToPharmacy,
    loading,
}: {
    isOpen: boolean;
    close: () => void;
    onChooseDifferentPharmacy: () => void;
    onSendToPharmacy: () => void;
    loading?: boolean;
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            opened={isOpen}
            onClose={close}
            title={t('previewDetails.pharmacyDoesNotCarryModal.title')}
        >
            <Stack gap="lg">
                <Stack>
                    <Body1>
                        {t(
                            'previewDetails.pharmacyDoesNotCarryModal.description1'
                        )}
                    </Body1>
                    <Body1>
                        {t(
                            'previewDetails.pharmacyDoesNotCarryModal.description2'
                        )}
                    </Body1>
                </Stack>
                <Stack>
                    <Button size="lg" onClick={onChooseDifferentPharmacy}>
                        {t(
                            'previewDetails.pharmacyDoesNotCarryModal.chooseDifferentPharmacy'
                        )}
                    </Button>
                    <Button
                        size="lg"
                        onClick={onSendToPharmacy}
                        variant="outline"
                        loading={loading}
                    >
                        {t('previewDetails.sendToPharmacy')}
                    </Button>
                </Stack>
            </Stack>
        </Modal>
    );
};
